import React, { useEffect, createElement } from 'react';
interface SEOHeadProps {
  title: string;
  description: string;
  canonical?: string;
  ogImage?: string;
  ogType?: string;
  twitterCard?: string;
  noindex?: boolean;
}
export function SEOHead({
  title,
  description,
  canonical,
  ogImage = 'https://cdn.magicpatterns.com/uploads/5m425UHDJynsrvkfvBo6sp/sj-website-logo-colour.svg',
  ogType = 'website',
  twitterCard = 'summary_large_image',
  noindex = false
}: SEOHeadProps) {
  useEffect(() => {
    // Set document title
    document.title = title;
    // Helper to set or create a meta tag
    const setMeta = (attr: string, attrValue: string, content: string) => {
      let el = document.querySelector(`meta[${attr}="${attrValue}"]`) as HTMLMetaElement | null;
      if (!el) {
        el = document.createElement('meta');
        el.setAttribute(attr, attrValue);
        document.head.appendChild(el);
      }
      el.setAttribute('content', content);
    };
    // Helper to set or create a link tag
    const setLink = (rel: string, href: string) => {
      let el = document.querySelector(`link[rel="${rel}"]`) as HTMLLinkElement | null;
      if (!el) {
        el = document.createElement('link');
        el.setAttribute('rel', rel);
        document.head.appendChild(el);
      }
      el.setAttribute('href', href);
    };
    // Meta description
    setMeta('name', 'description', description);
    // Robots
    if (noindex) {
      setMeta('name', 'robots', 'noindex, nofollow');
    } else {
      setMeta('name', 'robots', 'index, follow');
    }
    // Canonical
    if (canonical) {
      setLink('canonical', canonical);
    }
    // Open Graph
    setMeta('property', 'og:title', title);
    setMeta('property', 'og:description', description);
    setMeta('property', 'og:type', ogType);
    setMeta('property', 'og:site_name', 'Smith & Jengs Cleaning Services');
    if (ogImage) {
      setMeta('property', 'og:image', ogImage);
    }
    if (canonical) {
      setMeta('property', 'og:url', canonical);
    }
    // Twitter Card
    setMeta('name', 'twitter:card', twitterCard);
    setMeta('name', 'twitter:title', title);
    setMeta('name', 'twitter:description', description);
    if (ogImage) {
      setMeta('name', 'twitter:image', ogImage);
    }
    // Cleanup: reset title on unmount
    return () => {
      document.title = 'Smith & Jengs Cleaning Services';
    };
  }, [title, description, canonical, ogImage, ogType, twitterCard, noindex]);
  return null;
}